import { render, staticRenderFns } from "./MixinUpload.vue?vue&type=template&id=35afac74&scoped=true&lang=html&"
import script from "./MixinUpload.vue?vue&type=script&lang=js&"
export * from "./MixinUpload.vue?vue&type=script&lang=js&"
import style0 from "./MixinUpload.vue?vue&type=style&index=0&id=35afac74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35afac74",
  null
  
)

export default component.exports